import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import invoiceReducer from './slices/invoiceSlice';
import aboReducer from './slices/aboSlice';
import userReducer from './slices/userSlice';
import photoReducer from './slices/photoSlice';
import aiInstructionReducer from './slices/aiInstructionSlice';
import customerReducer from './slices/customerSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    invoices: invoiceReducer,
    abo: aboReducer,
    users: userReducer,
    photo: photoReducer,
    aiInstructions: aiInstructionReducer,
    customers: customerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 